// extracted by mini-css-extract-plugin
module.exports = {"_opened":"Section__opened__2CfNc","inner":"Section_inner__2iMZN"};